
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ggjf_4587181Y_45Zm0reSDIzSerJzq42nbbYxI8XbE81kncMeta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexTIadha6IP7PxkQaj1Kbuo7kF7WXix5TPmje_45rfVV8WsMeta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchgWIcfrHu0oNrI6upScdBCby3Jhngf9eCCu4NW5aRGbcMeta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexg4CbyTUfPtGL91njJpeg411wULut47J3q7RhiZV2S3AMeta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_937SCe9yycalgif6fiH9nfP89cGFpScBhisIfMsOLl_45fwMeta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index_RMjX96mIlhMFsvNN90vN13toOTp1FEweAjkJlvdN30Meta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93PpV3AIFsioI3GJHaHojs7IKtib0_45VR7lN0Oa8blWWn4Meta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexhAXUA3T0_459a1FV3OCWSccT8H8NkGfE2_4588TP3oF1rM4Meta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93zV2OOMohBglhFltEYq_45imk_45k5_S9pmF2ozdMoIB3rOwMeta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexakG1MwP3gTkwdY2QbvJOZdy9E9_45K8pvSFbwVuRQNtZ0Meta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexROZiObPVWD_45A51Ffi63FOv2TgAg19I_45DhXrHTS_BC7wMeta } from "/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index_RMjX96mIlhMFsvNN90vN13toOTp1FEweAjkJlvdN30Meta || {},
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexhAXUA3T0_459a1FV3OCWSccT8H8NkGfE2_4588TP3oF1rM4Meta || {},
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexakG1MwP3gTkwdY2QbvJOZdy9E9_45K8pvSFbwVuRQNtZ0Meta || {},
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexROZiObPVWD_45A51Ffi63FOv2TgAg19I_45DhXrHTS_BC7wMeta || {},
    component: () => import("/codebuild/output/src2298502660/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]